




import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class AuthLink extends Vue {
  @Prop({ type: String })
  readonly from?: string;

  @Prop({ type: String })
  readonly token?: string;

  beforeMount() {
    this.processCallback().catch(() => {
      this.$router.push({ name: 'main' });
    });
  }

  async processCallback() {
    if (this.$appName === undefined) {
      return;
    }

    if (!this.token) {
      throw new Error('Invalid request');
    }

    return this.$oauth.refreshToken(this.$appName).then(() => this.redirectAfterProcess());
  }

  async redirectAfterProcess() {
    return this.$router.push({ name: 'main' });
  }
}
